import OpportunityCard from './OpportunityCard';

export default OpportunityCard;
